import { render, staticRenderFns } from "./gen.vue?vue&type=template&id=4f192410"
import script from "./gen.vue?vue&type=script&lang=js"
export * from "./gen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports